<div class="action-cell-container" [class.edit-mode]="isEditMode" [class.view-mode]="!isEditMode">
  <button 
    mat-raised-button
    [color]="buttonColor"
    [disabled]="isEditMode || isProcessing"
    (click)="onButtonClick()"
    class="action-button">
    
    <!-- Loading spinner when processing -->
    <mat-spinner *ngIf="isProcessing" diameter="16" class="button-spinner"></mat-spinner>
    
    <!-- Button text -->
    <span [class.processing-text]="isProcessing">
      {{ isProcessing ? 'Processing...' : buttonText }}
    </span>
  </button>
</div>